import styled from "styled-components";
import { getWindowHeight } from "../utils";
import { useLazyLoadQuery } from "react-relay";
import { QueriesUserAppPermissionsQuery } from "../__generated__/QueriesUserAppPermissionsQuery.graphql";
import { UserAppPermissionsQuery } from "../Queries";
import LogoutButton from "../components/Buttons/LogoutButton";

export function NoAccessContainer() {
  const data = useLazyLoadQuery<QueriesUserAppPermissionsQuery>(
    UserAppPermissionsQuery,
    {}
  );

  return (
    <Container>
      <Content>
        <Header>
          <LogoutButton />
        </Header>
        <Body>
          <Card>
            <CardContainer>
              Je bent ingelogd als{" "}
              <i>
                {data.user?.firstName} {data.user?.lastName}
              </i>
              .
              <br />
              <br />
              <b>
                Je hebt geen rechten om deze pagina te kunnen bekijken. Neem
                contact op met het collectief.
              </b>
            </CardContainer>
          </Card>
        </Body>
      </Content>
    </Container>
  );
}

/*
 Styled components
*/
const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  overflow: hidden;
`;

const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: ${getWindowHeight()};
  overflow: auto;
  padding: 0px 1rem 0px 1rem;
  @media only screen and (min-width: 768px) {
    padding: 0px 48px 0px 0px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;

  margin-top: 24px;
  margin-bottom: 43px;
`;

const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  height: 100vh;
`;

const Card = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
`;

const CardContainer = styled.div`
  background-color: white;
  width: 400px;
  text-align: left;
  margin: 0 auto;
  padding: 30px 40px 40px 40px;
  font-size: 1.1em;
`;
